/*global google*/
/*global window*/
import React from "react";
import { useHistory } from "react-router-dom";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  GroundOverlay,
  Marker,
} from "react-google-maps";
import { ScrollElement, scroller } from "react-scroll";
import { Button, Form } from "tabler-react";
import * as qs from "qs";

const Map = withScriptjs(
  withGoogleMap((props) => {
    const centerLat =
      props.projects?.reduce(
        (sum, p) => sum + parseFloat(p?.nativeMapLatitude),
        0,
      ) / props.projects.length;
    const centerLong =
      props.projects?.reduce(
        (sum, p) => sum + parseFloat(p?.nativeMapLongitute),
        0,
      ) / props.projects.length;

    return (
      <GoogleMap
        ref={props.mapRef}
        mapTypeId={google.maps.MapTypeId.SATELLITE}
        options={{
          fullscreenControl: false,
          mapTypeControl: false,
          scrollwheel: true,
          signInControl: false,
          streetViewControl: false,
        }}
        defaultZoom={12}
        defaultCenter={{ lat: centerLat, lng: centerLong - 0.001 }}
      >
        {props.projects?.map((project) => (
          <>
            <GroundOverlay
              key={`GroundOverlay_${project.id}`}
              defaultUrl={project.nativeMapOverlayImageUrl}
              defaultBounds={
                new google.maps.LatLngBounds(
                  new google.maps.LatLng(
                    parseFloat(project.nativeMapOverlayImageLeftLatitude),
                    parseFloat(project.nativeMapOverlayImageLeftLongitude),
                  ),
                  new google.maps.LatLng(
                    parseFloat(project.nativeMapOverlayImageRightLatitude),
                    parseFloat(project.nativeMapOverlayImageRightLongitude),
                  ),
                )
              }
            />
            <Marker
              key={`Maker_${project.id}`}
              position={{
                lat:
                  parseFloat(project.nativeMapOverlayImageLeftLatitude) -
                  (parseFloat(project.nativeMapOverlayImageLeftLatitude) -
                    parseFloat(project.nativeMapOverlayImageRightLatitude)) /
                    2,
                lng:
                  parseFloat(project.nativeMapOverlayImageLeftLongitude) -
                  (parseFloat(project.nativeMapOverlayImageLeftLongitude) -
                    parseFloat(project.nativeMapOverlayImageRightLongitude)) /
                    2,
              }}
              motionTracking={false}
              icon={
                props.selectedProject.id === project.id
                  ? "/corretor/assets/images/pino_02.png"
                  : "/corretor/assets/images/pino_01.png"
              }
              onClick={() => props.onProjectClick(project)}
            />
          </>
        ))}
      </GoogleMap>
    );
  }),
);

const ProjectCard = ScrollElement(
  ({ project, selectedProject, setSelectedProject }) => (
    <div
      name={project.name}
      id={project.id}
      className="card mb-2"
      style={{
        backgroundColor: "#FEFEFE",
        color: "#00285B",
        overflow: "hidden",
        marginBottom: 10,
        boxShadow: "0px 8px 4px -4px rgba(32,32,32,0.9)",
        ...(selectedProject.id === project.id
          ? {
              backgroundColor: "#00285B",
              color: "white",
            }
          : {
              cursor: "pointer",
            }),
      }}
      onClick={() => {
        if (selectedProject.id !== project.id) {
          setSelectedProject(project);
        }
      }}
    >
      <img
        src={`/api/backoffice/projects/${project.id}/images/${project.images?.[0].id}`}
      />
      <h6 style={{ paddingTop: 4, paddingLeft: 8 }}>{project.name}</h6>
    </div>
  ),
);

function PortalMapPage() {
  const history = useHistory();

  const [initialized, setInitialized] = React.useState(false);
  const [mode, setMode] = React.useState("map");
  const [showMap, setShowMap] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [filteredData, setFilteredData] = React.useState([]);
  const [selectedProject, setSelectedProject] = React.useState({});
  const [filterOptions, setFilterOptions] = React.useState({});
  const [selectedFilters, setSelectedFilters] = React.useState({
    city: "",
    group: "",
    kind: "",
  });

  const mapRef = React.useRef(null);

  React.useEffect(() => {
    (async () => {
      const res = await fetch(`/api/portal/maps`);
      const json = await res.json();

      setFilterOptions(
        json.reduce(
          (obj, project) => {
            if (project.city && obj.city.indexOf(project.city) === -1)
              obj.city.push(project.city);
            if (project.group && obj.group.indexOf(project.group) === -1)
              obj.group.push(project.group);
            if (project.kind && obj.kind.indexOf(project.kind) === -1)
              obj.kind.push(project.kind);

            return obj;
          },
          {
            city: [],
            group: [],
            kind: [],
          },
        ),
      );

      setData(json);
      setFilteredData(json);

      if (history?.location?.search && history?.location?.search?.length > 0) {
        const params = qs.parse(history.location.search.replace("?", ""));
        if (params.mode && params.mode.length > 0) {
          setMode(params.mode);
        }

        if (params.marca && params.marca.length > 0) {
          setSelectedFilters({
            ...selectedFilters,
            group: params.marca,
          });
        }
      }

      setInitialized(true);
    })();
  }, []);

  React.useEffect(() => {
    setFilteredData(
      data.filter((project) => {
        if (
          selectedFilters.city !== "" &&
          selectedFilters.city !== project.city
        )
          return false;
        if (
          selectedFilters.group !== "" &&
          selectedFilters.group !== project.group
        )
          return false;
        if (
          selectedFilters.kind !== "" &&
          selectedFilters.kind !== project.kind
        )
          return false;

        return true;
      }),
    );

    setSelectedProject({});
  }, [selectedFilters]);

  React.useEffect(() => {
    if (selectedProject.id && data && mapRef.current) {
      scroller.scrollTo(`${selectedProject.id}`, {
        containerId: "projects",
        smooth: true,
      });

      mapRef.current.panTo(
        new google.maps.LatLng(
          parseFloat(selectedProject.nativeMapOverlayImageLeftLatitude) -
            (parseFloat(selectedProject.nativeMapOverlayImageLeftLatitude) -
              parseFloat(selectedProject.nativeMapOverlayImageRightLatitude)) /
              2,
          parseFloat(selectedProject.nativeMapOverlayImageLeftLongitude) -
            (parseFloat(selectedProject.nativeMapOverlayImageLeftLongitude) -
              parseFloat(selectedProject.nativeMapOverlayImageRightLongitude)) /
              2,
        ),
      );
    }
  }, [selectedProject]);

  return initialized ? (
    mode === "card-only" ? (
      <div>
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              padding: 8,
              paddingTop: 12,
              height: 192,
              width: "100%",
            }}
          >
            <h6 style={{ textAlign: "left", position: "relative", height: 24 }}>
              ENCONTRE O SEU PRODUTO
              <span
                style={{ position: "absolute", right: 0 }}
                onClick={() => setShowMap(!showMap)}
              >
                {showMap ? "Ver Lista" : "Ver Mapa"}
              </span>
            </h6>

            <Form.Select
              name="filterCity"
              value={selectedFilters["city"]}
              onChange={(e) => {
                setSelectedFilters({
                  ...selectedFilters,
                  city: e.target.value,
                });
              }}
            >
              <option value="#" disabled>
                Cidade
              </option>
              <option value="">Todos as cidades</option>
              {filterOptions?.city?.map((city) => (
                <option key={city} value={city}>
                  {city}
                </option>
              ))}
            </Form.Select>

            <div style={{ height: 8 }} />

            <Form.Select
              name="filterKind"
              value={selectedFilters["kind"]}
              onChange={(e) => {
                setSelectedFilters({
                  ...selectedFilters,
                  kind: e.target.value,
                });
              }}
            >
              <option value="#" disabled>
                Tipo de projeto
              </option>
              <option value="">Todos os tipos</option>
              {filterOptions?.kind?.map((kind) => (
                <option key={kind} value={kind}>
                  {kind === "residential"
                    ? "Residencial"
                    : kind === "business"
                      ? "Empresarial"
                      : kind === "area"
                        ? "Área"
                        : kind === "mixed"
                          ? "Misto"
                          : ""}
                </option>
              ))}
            </Form.Select>

            <div style={{ height: 8 }} />

            <Form.Select
              name="filterGroup"
              value={selectedFilters["group"]}
              onChange={(e) => {
                setSelectedFilters({
                  ...selectedFilters,
                  group: e.target.value,
                });
              }}
            >
              <option value="#" disabled>
                Marcas
              </option>
              <option value="">Todas as marcas</option>
              {filterOptions?.group?.map((group) => (
                <option key={group} value={group}>
                  {group}
                </option>
              ))}
            </Form.Select>

            <div style={{ height: 8 }} />
          </div>
          {showMap ? (
            <div
              style={{
                bottom: 0,
                right: 0,
                position: "absolute",
                top: 186,
                left: 0,
              }}
            >
              <Map
                mapRef={mapRef}
                projects={filteredData}
                selectedProject={selectedProject}
                onProjectClick={setSelectedProject}
                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyB4kgwYSTYdTsT6efHQLYOPZUuB-S5zTNI&v=3.42&libraries=geometry,drawing,places"
                loadingElement={<div style={{ height: `100%` }} />}
                containerElement={<div style={{ height: `100%` }} />}
                mapElement={<div style={{ height: `100%` }} />}
              />
            </div>
          ) : (
            <div style={{ overflowY: "scroll", padding: "0 8px" }}>
              {filteredData?.map((project) => (
                <div key={project.id} style={{ width: "100%" }}>
                  <ProjectCard
                    project={project}
                    selectedProject={selectedProject}
                    setSelectedProject={setSelectedProject}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
        {selectedProject?.id && (
          <div
            style={{
              backgroundColor: "rgba(255,255,255, 0.96)",
              display: "block",
              width: "100%",
              padding: "12px 16px 18px",
              position: "absolute",
              top: 0,
              bottom: 0,
            }}
          >
            <h3>
              Bem-vindo ao
              <br />
              {selectedProject.name}
            </h3>
            <p style={{ marginBottom: 24 }}>
              {selectedProject.portalDescription}
            </p>
            <a
              target="_blank"
              href={selectedProject.portalUrl}
              style={{
                border: "1px solid #00265C",
                color: "#00265C",
                display: "block",
                padding: "8px 10px",
                textAlign: "center",
                marginBottom: 32,
              }}
            >
              Saber mais
            </a>
            <a
              onClick={() => setSelectedProject({})}
              style={{
                border: "1px solid #00265C",
                backgroundColor: "#00265C",
                color: "#FFFFFF",
                display: "block",
                padding: "8px 10px",
                textAlign: "center",
                position: "absolute",
                bottom: 16,
                left: 16,
                right: 16,
              }}
            >
              Fechar
            </a>
          </div>
        )}
      </div>
    ) : (
      <div style={{ height: "100%", width: "100%" }}>
        <div
          style={{
            bottom: 0,
            right: 0,
            position: "absolute",
            top: 0,
            left: 384,
          }}
        >
          <Map
            mapRef={mapRef}
            projects={filteredData}
            selectedProject={selectedProject}
            onProjectClick={setSelectedProject}
            googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyB4kgwYSTYdTsT6efHQLYOPZUuB-S5zTNI&v=3.42&libraries=geometry,drawing,places"
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={<div style={{ height: `100%` }} />}
            mapElement={<div style={{ height: `100%` }} />}
          />
        </div>
        <div
          style={{
            bottom: 0,
            left: 0,
            position: "absolute",
            top: 0,
            width: 384,
            backgroundColor: "rgba(255,255,255, 0.9)",
            padding: 0,
          }}
        >
          <div
            style={{
              padding: 8,
              paddingTop: 12,
              position: "absolute",
              height: 192,
              width: "100%",
            }}
          >
            <h6 style={{ textAlign: "left" }}>ENCONTRE O SEU PRODUTO</h6>

            <Form.Select
              name="filterCity"
              value={selectedFilters["city"]}
              onChange={(e) => {
                setSelectedFilters({
                  ...selectedFilters,
                  city: e.target.value,
                });
              }}
            >
              <option value="#" disabled>
                Cidade
              </option>
              <option value="">Todos as cidades</option>
              {filterOptions?.city?.map((city) => (
                <option key={city} value={city}>
                  {city}
                </option>
              ))}
            </Form.Select>

            <div style={{ height: 8 }} />

            <Form.Select
              name="filterKind"
              value={selectedFilters["kind"]}
              onChange={(e) => {
                setSelectedFilters({
                  ...selectedFilters,
                  kind: e.target.value,
                });
              }}
            >
              <option value="#" disabled>
                Tipo de projeto
              </option>
              <option value="">Todos os tipos</option>
              {filterOptions?.kind?.map((kind) => (
                <option key={kind} value={kind}>
                  {kind === "residential"
                    ? "Residencial"
                    : kind === "business"
                      ? "Empresarial"
                      : kind === "area"
                        ? "Área"
                        : kind === "mixed"
                          ? "Misto"
                          : ""}
                </option>
              ))}
            </Form.Select>

            <div style={{ height: 8 }} />

            <Form.Select
              name="filterGroup"
              value={selectedFilters["group"]}
              onChange={(e) => {
                setSelectedFilters({
                  ...selectedFilters,
                  group: e.target.value,
                });
              }}
            >
              <option value="#" disabled>
                Marcas
              </option>
              <option value="">Todas as marcas</option>
              {filterOptions?.group?.map((group) => (
                <option key={group} value={group}>
                  {group}
                </option>
              ))}
            </Form.Select>

            <div style={{ height: 8 }} />
          </div>
          <div
            id="projects"
            style={{
              overflowY: "scroll",
              padding: 8,
              bottom: 0,
              left: 0,
              position: "absolute",
              top: 192,
              width: "100%",
            }}
          >
            {filteredData?.map((project) => (
              <ProjectCard
                key={project.id}
                project={project}
                selectedProject={selectedProject}
                setSelectedProject={setSelectedProject}
              />
            ))}
          </div>
        </div>

        {selectedProject?.id && (
          <div
            style={{
              backgroundColor: "rgba(255,255,255, 0.95)",
              borderRadius: 8,
              padding: "12px 16px 18px",
              position: "absolute",
              right: 16,
              top: 16,
              width: 320,
            }}
          >
            <h4>
              Bem-vindo ao
              <br />
              {selectedProject.name}
            </h4>
            <p style={{ marginBottom: 18 }}>
              {selectedProject.portalDescription}
            </p>
            <a
              target="_blank"
              href={selectedProject.portalUrl}
              style={{
                border: "1px solid #00265C",
                color: "#00265C",
                display: "block",
                padding: "8px 10px",
                textAlign: "center",
              }}
            >
              Saber mais
            </a>
            <a
              onClick={() => setSelectedProject({})}
              style={{
                backgroundColor: "#00265C",
                border: "1px solid #00265C",
                borderRadius: 25,
                color: "#FFFFFF",
                cursor: "pointer",
                display: "block",
                fontWeight: "bold",
                height: 25,
                padding: 0,
                position: "absolute",
                right: 8,
                textAlign: "center",
                top: 8,
                width: 25,
              }}
            >
              X
            </a>
          </div>
        )}
      </div>
    )
  ) : (
    <div
      className="page"
      style={{
        backgroundImage: "url('./assets/images/landing_background.jpg')",
        backgroundSize: "cover",
      }}
    />
  );
}

export default PortalMapPage;
